import { gql, TypedDocumentNode } from "@apollo/client";
import { PAGE_INFO_FRAGMENT } from "@/hooks/usePagination";
import type { MemberElectionsQueryResponse, MemberElectionsQueryVariables } from "./types";

export const MEMBER_ELECTIONS_QUERY: TypedDocumentNode<MemberElectionsQueryResponse, MemberElectionsQueryVariables> =
  gql`
    query MemberElections($first: Int, $last: Int, $before: String, $after: String, $search: String) {
      membershipApplications(
        first: $first
        last: $last
        before: $before
        after: $after
        applicationType: member
        status: approved
        pendingElection: true
        search: $search
      ) {
        nodes {
          id
          profilePhotoUrl
          email
          approvedAt
          electionDate {
            id
            electionDate
          }
          electionMemberClassification
          person {
            pgaId
            displayName
            primarySection {
              id
              name
            }
            primaryFacility {
              id
              name
            }
          }
        }
        ...PageInfo
      }
    }
    ${PAGE_INFO_FRAGMENT}
  `;
